
import { Widget } from "../../../../redux/slices/widget/widgetModel"

type Props = {
  widgetId: string,
  className: string,
  widget: Widget,
  autoLayout? : boolean,
  displayIcon?: boolean,
  active?: boolean,
  ribbonType?: '' | 'recent' | 'favorite' | 'recommended' | 'popular' | 'template'
}

const ribbonIconBorderColor = {
    'recent'        : ['border-warning' , 'bi bi-stars text-white'],
    'favorite'      : ['border-danger'  , 'bi bi-heart-fill text-white'],
    'recommended'   : ['border-info'    , 'bi bi-hand-thumbs-up-fill text-white'],
    'popular'       : ['border-success' , 'bi bi-star text-white'],
    'template'      : ['border-primary' , 'bi bi-columns text-white'],
}

const CardWidget: React.FC<Props> = ({ widgetId, className, widget, ribbonType, autoLayout, displayIcon, active}) => {
    const thisWidget = document.getElementsByClassName('widget')[0]
    
    return (
        <>
            <div className={`${className} mb-2 pt-2 pb-1 ${active === true? "bg-gradient-primary rounded bg-opacity-50":" bg-hover-light-primary border border-1 border-secondary border-hover-primary rounded"}`}>
            <div id={`${widgetId}`} className="widget">
                <div>{widget.name}</div>
            </div>
            </div>
        </>
    )
}

export { CardWidget }